// Minimal status timeline derived from ticket status + timestamps.
// Full audit log deferred to Phase 09.
import { RepairTicket, STATUS_LABELS, STATUS_COLORS } from "../repair-api";

interface Props {
  ticket: RepairTicket;
}

interface TimelineEntry {
  label: string;
  date?: string;
  done: boolean;
  active: boolean;
}

const STATUS_ORDER = [
  "received", "diagnosing", "quoted", "approved", "repairing",
  "waiting_parts", "sent_to_vendor", "received_back", "done", "delivered",
];

export function StatusTimeline({ ticket }: Props) {
  if (ticket.status === "cancelled") {
    return (
      <div className="rounded-lg border border-destructive/30 bg-destructive/5 p-4 text-sm">
        <span className="font-medium text-destructive">Phiếu đã bị huỷ</span>
        <p className="mt-1 text-xs text-muted-foreground">Cập nhật lần cuối: {fmtShort(ticket.updatedAt)}</p>
      </div>
    );
  }

  const currentIdx = STATUS_ORDER.indexOf(ticket.status);

  const entries: TimelineEntry[] = STATUS_ORDER.map((s, idx) => ({
    label: STATUS_LABELS[s] ?? s,
    date: idx === currentIdx ? ticket.updatedAt : idx === 0 ? ticket.receivedAt : undefined,
    done: idx < currentIdx,
    active: idx === currentIdx,
  }));

  // Also show delivered separately if applicable.
  if (ticket.status === "delivered" && ticket.deliveredAt) {
    entries[entries.length - 1].date = ticket.deliveredAt;
  }

  return (
    <ol className="relative ml-2 border-l space-y-4">
      {entries.map((e, i) => (
        <li key={i} className="ml-4">
          {/* Dot */}
          <span
            className={`absolute -left-1.5 mt-1 h-3 w-3 rounded-full border-2 border-background
              ${e.active ? "bg-primary" : e.done ? "bg-muted-foreground" : "bg-border"}`}
          />
          <div className="flex items-baseline gap-2">
            <span className={`text-sm font-medium ${e.active ? "text-foreground" : e.done ? "text-muted-foreground" : "text-border"}`}>
              {e.label}
            </span>
            {e.active && (
              <span className={`rounded-full px-1.5 py-0.5 text-[10px] font-medium ${STATUS_COLORS[ticket.status] ?? ""}`}>
                Hiện tại
              </span>
            )}
          </div>
          {e.date && (
            <p className="text-xs text-muted-foreground">{fmtShort(e.date)}</p>
          )}
        </li>
      ))}
    </ol>
  );
}

function fmtShort(d?: string) {
  if (!d) return "";
  return new Date(d).toLocaleString("vi-VN", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}
